import styled from 'styled-components/macro'

export const TotalResultsText = styled.div`
  flex: 1 0;
  white-space: nowrap;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 27px;
  color: #303030;
  margin-bottom: 8px;
`
